import React, { useMemo } from "react";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import GaugeChart from "./GaugeChart";

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

const pieOptions = {
  responsive: true,
  maintainAspectRatio: false,
  layout: {
    padding: { top: 36, right: 56, bottom: 36, left: 56 },
  },
  plugins: {
    legend: { display: false },
    datalabels: {
      labels: {
        value: {
          color: "#fff",
          font: { size: 12, weight: "bold" },
          formatter: (value) => (value > 0 ? value : ""),
          anchor: "center",
          align: "center",
        },
        name: {
          color: (ctx) => ctx.dataset.backgroundColor[ctx.dataIndex],
          font: { size: 10, weight: "bold" },
          formatter: (_, ctx) => {
            const words = ctx.chart.data.labels[ctx.dataIndex].split(" ");
            if (words.length <= 1) return words[0];
            const mid = Math.ceil(words.length / 2);
            return words.slice(0, mid).join(" ") + "\n" + words.slice(mid).join(" ");
          },
          anchor: "end",
          align: "end",
          offset: 4,
          textAlign: "center",
        },
      },
    },
    tooltip: {
      callbacks: {
        label: (ctx) => ` ${ctx.label}: ${ctx.raw}`,
      },
    },
  },
};

const pie_colors = ["#2563EB", "#F59E0B", "#37A800", "#DC2626", "#7C3AED", "#0EA5E9", "#EC4899", "#14B8A6"];

const MetricsCards = ({
  aderencia = 0,
  cobertura = 0,
  m300Aderencia = 83.0,
  m300Cobertura = 86.0,
  errosPorTipo = [],
}) => {
  const errorsData = useMemo(() => ({
    labels: errosPorTipo.map((e) => e.tipoErro),
    datasets: [
      {
        data: errosPorTipo.map((e) => e.qtdErros),
        backgroundColor: errosPorTipo.map((_, i) => pie_colors[i % pie_colors.length]),
        borderWidth: 2,
        borderColor: "#fff",
      },
    ],
  }), [errosPorTipo]);

  const totalErros = useMemo(
    () => errosPorTipo.reduce((acc, e) => acc + (e.qtdErros ?? 0), 0),
    [errosPorTipo],
  );

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6 items-stretch">
      <div className="bg-white rounded-lg shadow p-4 flex flex-col">
        <h3 className="text-base font-bold text-[#1A2B49] text-center mb-1">
          Aderência a Rota
        </h3>
        <div className="flex-1 flex items-center justify-center w-full">
          <GaugeChart
            value={aderencia}
            maxValue={100}
            referenceValue={m300Aderencia}
            referenceLabel="M300"
            valueLabel="Aderência Calculada"
          />
        </div>
      </div>

      <div className="bg-white rounded-lg shadow p-4 flex flex-col">
        <h3 className="text-base font-bold text-[#1A2B49] text-center mb-1">
          Cobertura de Carteira
        </h3>
        <div className="flex-1 flex items-center justify-center w-full">
          <GaugeChart
            value={cobertura}
            maxValue={100}
            referenceValue={m300Cobertura}
            referenceLabel="M300"
            valueLabel="Cobertura da Carteira"
          />
        </div>
      </div>

      <div className="bg-white rounded-lg shadow p-4 flex flex-col">
        <h3 className="text-base font-bold text-[#1A2B49] text-center mb-1">
          Erros de Pesquisa
        </h3>
        <div className="flex-1 flex items-center justify-center w-full">
          {totalErros === 0 ? (
            <div className="flex h-[230px] items-center justify-center text-sm text-gray-400">
              Sem erros registrados
            </div>
          ) : (
            <div className="w-full" style={{ height: 230 }}>
              <Pie data={errorsData} options={pieOptions} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MetricsCards;
